// TMOS User Position Management Page
// Date: December 19, 2025
// Purpose: Main page for tenant admins to manage user position assignments

import React from 'react';
import { useLanguage } from '@/state/language/LanguageProvider';
import { useAuth } from '@/state/auth/AuthProvider';
import { UserPositionList } from '@/components/user-position/UserPositionList';
import { Card } from '@/components/ui/Card';

export const UserPositionManagementPage: React.FC = () => {
  const { t } = useLanguage();
  const { user: currentUser } = useAuth();

  return (
    <div className="min-h-screen bg-[var(--color-secondary-bg)]">
      <div className="container mx-auto px-4 py-6">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-[var(--color-surface-text)] mb-2">
            {t('userPositionManagement.title') || 'User Position Management'}
          </h1>
          <p className="text-[var(--color-secondary-text)]">
            {t('userPositionManagement.description') || 
              'Assign and manage business positions for users. Positions determine role assignments and can be used as stakeholders.'}
          </p>
        </div>

        {/* User Position List */}
        <Card>
          <div className="p-6">
            <UserPositionList tenantId={currentUser?.tenantId} />
          </div>
        </Card>
      </div>
    </div>
  );
};

